import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import HistologiaApi from '../../../histologia/common/histologia.api';
import * as commonActions from '@common/common.action';
import { Container, Badge } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import { colorsSystem } from '@common/util/defaultValues';
import IntlMessage from '../../../../helpers/intlMessage';

function Laminas ({ laudo }) {
  const dispatch = useDispatch();
  const [lista, setLista] = useState([]);

  useEffect(() => {
    laudo && getLaminas(laudo);
  }, [laudo]);

  const returnColor = status => {
    switch (status) {
      case 'F':
        return colorsSystem.VERDE;
      case 'N':
        return colorsSystem.AMARELO;
      default:
        return colorsSystem.VERMELHO;
    }
  };

  const returnStatusText = status => {
    switch (status) {
      case 'F':
        return <IntlMessage id = "dashboards.reports.ready"/>;
      case 'N':
        return <IntlMessage id = "dashboards.reports.pending"/>;
      default:
        return <IntlMessage id = "dashboards.reports.inProgress"/>;
    }
  };

  const nrLaminaFormatted = (item) => {
    return (
      <span>
        {`${item.nrLamina} `}
        {item.laminaCancelada && (
          <Badge style={{fontSize: '10px', backgroundColor: '#f15959', color: '#fff'}}>
            CANCELADA
          </Badge>
        )}
      </span>
    )
  }

  const statusFormatted = (item) => {
    return (
      <Badge style={{fontSize: '12px', backgroundColor: returnColor(item.status), color: `${item.status === 'N' ? '#333' : '#fff'}`}}>
        {returnStatusText(item.status)}
      </Badge>
    )
  }

  const getLaminas = laudoId => {
    dispatch(commonActions.showFadeCarregando(true));

    HistologiaApi.getLaminasPorLaudoId(laudoId, true).then(resp => {
      setLista(resp.todas);
      dispatch(commonActions.showFadeCarregando(false));
    });
  };

  return (
    <Container fluid className='mv-workspace-container'>
      <DataTable
        value={lista}
        responsive={true}
        selectionMode='single'
        style={{ height: '100%' }}
        columnResizeMode='expand'
        scrollable={true}
        scrollHeight='71vh'
        scrollWidth='100%'
        resizableColumns={true}
        reorderableColumns={true}
        rowsPerPageOptions={[10, 20, 50]}
        lazy={false}
        paginator={false}
        emptyMessage={<IntlMessage id = "dashboards.examDetail.table.noResultsFound"/>}
        alwaysShowPaginator={true}
        autoLayout={true}
        totalRecords={lista.length}
        onSelectionChange={e => {}}
      >
        <Column
          sortable={true}
          field='nrLamina'
          style={{ width: '250px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.blade"/>}
          body={nrLaminaFormatted}
        />
        <Column
          sortable={true}
          field='tipoLamina'
          style={{ width: '150px' }}
          header={<IntlMessage id = "general.requestsPanel.type"/>}
        />
        <Column
          sortable={true}
          field='status'
          style={{ width: '150px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.status"/>}
          body={statusFormatted}
        />
        <Column
          sortable={true}
          field='coloracao'
          style={{ width: '150px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.coloring"/>}
        />
        <Column
          sortable={true}
          field='nomeTecnico'
          style={{ width: '250px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.technician"/>}
        />
        <Column
          sortable={true}
          field='dataDeCadastro'
          style={{ width: '180px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.registrationDate"/>}
        />
      </DataTable>
    </Container>
  );
}

export default Laminas;



// WEBPACK FOOTER //
// ./src/pages/main/ControleBlocosLaminas/Laminas/index.js